module.exports = __webpack_public_path__ + "img/marathonchallenge.c56dd269.png";